exports = module.exports = require("../../../../build/module-builder/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bp3-dialog-container {\n  height: 100%; }\n\n.channel-web__style__dialog___2Gppi {\n  max-height: 90%;\n  background-color: white !important;\n  overflow-y: auto; }\n  .channel-web__style__dialog___2Gppi .channel-web__style__form___1aYTn,\n  .channel-web__style__dialog___2Gppi .bp3-dialog-body {\n    overflow: auto;\n    height: calc(100% - 34px); }\n  .channel-web__style__dialog___2Gppi .bp3-button {\n    transition: color 0.3s, background 0.3s; }\n\n.channel-web__style__dialogBody___3cw25 {\n  position: relative;\n  margin: 0 !important;\n  padding: 20px !important;\n  padding-bottom: 6px !important;\n  overflow: auto; }\n", ""]);

// exports
exports.locals = {
	"dialog": "channel-web__style__dialog___2Gppi",
	"form": "channel-web__style__form___1aYTn",
	"dialogBody": "channel-web__style__dialogBody___3cw25"
};